module.exports = __webpack_public_path__ + "static/1365705067.7fb9e2c5.jpg";